module.exports = __webpack_public_path__ + "img/banner_Up_cultura _vn_200.05e54380.png";